// app/javascript/controllers/allocations_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["assignment", "panel", "container", "template", "total"]

  connect() {
    this.index = Date.now()
    this.toggle()
    this.updateTotal()
  }

  toggle() {
    if (!this.hasAssignmentTarget || !this.hasPanelTarget) return

    const direct = this.assignmentTarget.value === "direct"
    this.panelTarget.classList.toggle("d-none", !direct)
  }

  add(event) {
    event.preventDefault()

    this.index += 1

    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_ALLOCATION_RECORD",
      this.index.toString()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.updateTotal()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-allocation-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }

    this.updateTotal()
  }

  updateTotal() {
    if (!this.hasTotalTarget || !this.hasContainerTarget) return

    const inputs = this.containerTarget.querySelectorAll(
      "input[name*='[percentage]'], input[name*='[part]']"
    )

    const total = Array.from(inputs).reduce((sum, input) => {
      const row = input.closest("[data-allocation-row]")
      if (row?.classList.contains("d-none")) return sum

      const destroyInput = row?.querySelector("input[name*='[_destroy]']")
      if (destroyInput?.value === "1") return sum

      return sum + this.parseDecimal(input.value)
    }, 0)

    this.totalTarget.textContent = total.toFixed(2)
    this.totalTarget.classList.toggle("text-success", total === 100)
    this.totalTarget.classList.toggle("text-danger", total !== 100)
  }

  parseDecimal(value) {
    return Number.parseFloat(value.toString().replace(",", ".")) || 0
  }
}